module.exports = __webpack_public_path__ + "img/901093628.14a7ba4d.png";